import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $isUneditable: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};

  padding: ${({ theme }) => theme.spacing(6)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      background: ${theme.palette.background.default};
    `};

  ${({ $isUneditable }) =>
    $isUneditable &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  text-align: center;
`;

export const ImageContainer = styled.div`
  margin: 0 auto;

  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Description = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Interactions = styled.div`
  margin: 0 auto;
`;
